import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    isCollapse: false,
    subIsCollapse: false,
    subMenuState: false,
    /** 频道管理二级菜单宽度（px），支持拖拽调整 */
    subMenuWidth: 170,
    /** 拖拽中的临时宽度，避免拖拽过程频繁重渲染菜单树 */
    subMenuPendingWidth: 170,
    subMenuResizing: false
  },
  mutations: {
    UPDATE_STATE(state, payload) {
      Vue.set(state, payload.name, payload.data)
    }
  },
  actions: {}
}
